module.exports = __webpack_public_path__ + "static/img/wd4.7159575.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workimg/wd4.png
// module id = kWJy
// module chunks = 10